import {
  CarPortfolioHeatmapChartItem,
  CarPortfolioHeatmapChartDataset,
} from "../assetAllocation/asset-allocation-types";

export const useChartSimulatedForwardProbabilitiesData = ({
  nominalHeatmap,
  realHeatmap,
  data1Id,
  data2Id,
  isReal,
  isCompare,
  chartDateRange1,
  chartDateRange2,
}: {
  nominalHeatmap: CarPortfolioHeatmapChartItem[];
  realHeatmap: CarPortfolioHeatmapChartItem[];
  data1Id?: string;
  data2Id?: string;
  isReal: boolean;
  isCompare: boolean;
  chartDateRange1: number;
  chartDateRange2: number;
}) => {
  const realLabel = isReal ? "Real" : "Nominal";

  const selectedHeatmap1 = isReal ? realHeatmap : nominalHeatmap;

  const selectedItem1 = selectedHeatmap1.find((i) => i.id === data1Id);
  const selectedItem1Datasets =
    selectedItem1?.datasets.map<CarPortfolioHeatmapChartDataset>((ds) => ({
      ...ds,
      x: ds.x.slice(0, chartDateRange1 + 1),
      y: ds.y.slice(0, chartDateRange1 + 1),
    })) ?? [];

  const selectedItem2 = isCompare
    ? selectedHeatmap1.find((i) => i.id === data2Id)
    : undefined;
  const selectedItem2Datasets =
    selectedItem2?.datasets.map<CarPortfolioHeatmapChartDataset>((ds) => ({
      ...ds,
      x: ds.x.slice(0, chartDateRange2 + 1),
      y: ds.y.slice(0, chartDateRange2 + 1),
    })) ?? [];

  return {
    selectedHeatmap1,
    label1: `${selectedItem1?.label} Simulated Outcome (${realLabel})`,
    label1Downside: `${selectedItem1?.label} Simulated Downside (${realLabel})`,
    datasets1: selectedItem1Datasets,

    isCompare,
    label2: `${selectedItem2?.label} Simulated Outcome (${realLabel})`,
    label2Downside: `${selectedItem2?.label} Simulated Downside (${realLabel})`,
    datasets2: selectedItem2Datasets,
  };
};

export type SimulatedForwardProbabilitiesData = ReturnType<
  typeof useChartSimulatedForwardProbabilitiesData
>;
